import { render } from "./AiGetInTouchForm.vue?vue&type=template&id=37d28602"
import script from "./AiGetInTouchForm.vue?vue&type=script&lang=js"
export * from "./AiGetInTouchForm.vue?vue&type=script&lang=js"

import "./AiGetInTouchForm.vue?vue&type=style&index=0&id=37d28602&lang=scss"

import exportComponent from "/home/webdevs/livesite/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__